import React, { ReactElement } from "react";

type Props = {
  children: ReactElement<any, any>;
};

function CP_Container({ children }: Props) {
  return (
    <div className="SCP_Container">
      <div className="SCP_Form">{children}</div>
    </div>
  );
}

export default CP_Container;
